'use client'

import { forwardRef } from 'react'

import styles from './styles.module.css'
import { ICheckBoxProps } from './types'

const Checkbox = forwardRef<HTMLInputElement, ICheckBoxProps>(
  ({ typeBox = 'checkbox', type = 'checkbox', ...props }, ref) => {
    return (
      <label
        htmlFor={`${props.id ?? props.name}`}
        className={`flex flex-row items-center prose-body-small cursor-pointer text-black
          ${typeBox !== 'switch' ? 'gap-1.5' : 'gap-2'}
          ${props.className}
        `}
      >
        <input
          id={`${props.id ?? props.name}`}
          type={type}
          ref={ref}
          {...props}
          className={`min-w-6 min-h-6 border-none appearance-none cursor-pointer ${
            styles[typeBox!]
          }`}
        />
        {props.label ? props.label : null}
      </label>
    )
  },
)

export default Checkbox
